export type StoreTemplateStyleId = 'sophisticated_feminine' | 'premium_fashion' | 'tech_showcase';

export type StoreTemplatePalette = {
  id: string;
  name: string;
  primary: string;
  secondary: string;
  light: string;
};

export const STORE_TEMPLATE_STYLES: Array<{ id: StoreTemplateStyleId; name: string; description: string }> = [
  {
    id: 'sophisticated_feminine',
    name: 'Clasico Fluxi',
    description: 'Limpio, claro y enfocado en conversion.',
  },
  {
    id: 'premium_fashion',
    name: 'Moda premium',
    description: 'Editorial, sobrio y aspiracional.',
  },
  {
    id: 'tech_showcase',
    name: 'Tech showcase',
    description: 'Oscuro, preciso y con contraste alto.',
  },
];

export const STORE_TEMPLATE_PALETTES: StoreTemplatePalette[] = [
  { id: 'orange', name: 'Naranja', primary: '#FF8A1F', secondary: '#B84A10', light: '#FFF0DC' },
  { id: 'coffee', name: 'Cafe', primary: '#F26A21', secondary: '#9A3B12', light: '#FFECDD' },
  { id: 'blue', name: 'Azul', primary: '#3B82F6', secondary: '#1E3A8A', light: '#DBEAFE' },
  { id: 'deep_blue', name: 'Azul oscuro', primary: '#1E3A8A', secondary: '#0B1120', light: '#DBEAFE' },
  { id: 'navy', name: 'Azul profundo', primary: '#1D4ED8', secondary: '#172554', light: '#DBEAFE' },
  { id: 'midnight_blue', name: 'Azul medianoche', primary: '#102A43', secondary: '#061526', light: '#D9EAF7' },
  { id: 'ice_blue', name: 'Azul hielo', primary: '#7DD3FC', secondary: '#075985', light: '#E0F2FE' },
  { id: 'sky', name: 'Azul cielo', primary: '#38BDF8', secondary: '#075985', light: '#E0F2FE' },
  { id: 'cyan', name: 'Cian', primary: '#06B6D4', secondary: '#0E7490', light: '#CFFAFE' },
  { id: 'teal', name: 'Turquesa', primary: '#14B8A6', secondary: '#0F766E', light: '#CCFBF1' },
  { id: 'purple', name: 'Morado', primary: '#8B5CF6', secondary: '#4C1D95', light: '#EDE9FE' },
  { id: 'indigo', name: 'Indigo', primary: '#4F46E5', secondary: '#312E81', light: '#E0E7FF' },
  { id: 'deep_violet', name: 'Violeta oscuro', primary: '#581C87', secondary: '#2E1065', light: '#F3E8FF' },
  { id: 'lavender', name: 'Lavanda', primary: '#A78BFA', secondary: '#5B21B6', light: '#F3E8FF' },
  { id: 'plum', name: 'Ciruela', primary: '#7E22CE', secondary: '#3B0764', light: '#F3E8FF' },
  { id: 'red', name: 'Rojo', primary: '#F04438', secondary: '#A8201B', light: '#FDE7E4' },
  { id: 'wine', name: 'Vinotinto', primary: '#E53935', secondary: '#9F1D1D', light: '#FDE4E2' },
  { id: 'aubergine', name: 'Berenjena', primary: '#4C1D3D', secondary: '#24091D', light: '#F3E1EF' },
  { id: 'pink', name: 'Rosado', primary: '#EC4899', secondary: '#9D174D', light: '#FCE7F3' },
  { id: 'dusty_rose', name: 'Rosa empolvado', primary: '#B76E79', secondary: '#6B2E42', light: '#F8E6EA' },
  { id: 'mauve_soft', name: 'Malva suave', primary: '#C08497', secondary: '#7A2E48', light: '#F8E7EC' },
  { id: 'coral', name: 'Coral', primary: '#FB6F5F', secondary: '#B42318', light: '#FFE4DE' },
  { id: 'green', name: 'Verde', primary: '#10B981', secondary: '#064E3B', light: '#D1FAE5' },
  { id: 'emerald', name: 'Esmeralda', primary: '#047857', secondary: '#064E3B', light: '#D1FAE5' },
  { id: 'deep_green', name: 'Verde oscuro', primary: '#166534', secondary: '#052E16', light: '#DCFCE7' },
  { id: 'sage', name: 'Salvia', primary: '#8A9A5B', secondary: '#3F4F24', light: '#EEF2D6' },
  { id: 'lime', name: 'Lima', primary: '#84CC16', secondary: '#3F6212', light: '#ECFCCB' },
  { id: 'olive', name: 'Oliva', primary: '#6B8E23', secondary: '#3F4F16', light: '#EEF5D2' },
  { id: 'yellow', name: 'Amarillo', primary: '#D9B800', secondary: '#4A3A00', light: '#FFF7B2' },
  { id: 'amber', name: 'Ambar', primary: '#F59E0B', secondary: '#92400E', light: '#FEF3C7' },
  { id: 'champagne', name: 'Champagne', primary: '#C6A15B', secondary: '#6F5525', light: '#F7EBCB' },
  { id: 'sand', name: 'Arena', primary: '#C9A46A', secondary: '#6F4E1E', light: '#F7EAD0' },
  { id: 'cocoa', name: 'Cacao', primary: '#9A5A2E', secondary: '#4A2512', light: '#F3E4D6' },
  { id: 'espresso', name: 'Espresso', primary: '#5C3A21', secondary: '#2A160B', light: '#F3E7DA' },
  { id: 'taupe', name: 'Taupe', primary: '#8B7E74', secondary: '#3F3732', light: '#EEE7E1' },
  { id: 'electric_lime', name: 'Lima electrica', primary: '#A3E635', secondary: '#365314', light: '#ECFCCB' },
  { id: 'steel', name: 'Acero', primary: '#64748B', secondary: '#334155', light: '#E2E8F0' },
  { id: 'slate', name: 'Negro', primary: '#111111', secondary: '#000000', light: '#E5E5E5' },
];

export const STORE_TEMPLATE_PALETTES_BY_STYLE: Record<StoreTemplateStyleId, string[]> = {
  tech_showcase: ['orange', 'blue', 'deep_blue', 'cyan', 'teal', 'indigo', 'deep_violet', 'purple', 'red', 'pink', 'green', 'deep_green', 'yellow', 'amber', 'electric_lime', 'steel', 'slate'],
  sophisticated_feminine: ['orange', 'coral', 'blue', 'deep_blue', 'navy', 'midnight_blue', 'ice_blue', 'sky', 'cyan', 'teal', 'purple', 'lavender', 'mauve_soft', 'red', 'pink', 'green', 'lime', 'olive', 'yellow', 'amber', 'sand', 'cocoa', 'slate'],
  premium_fashion: ['coffee', 'espresso', 'taupe', 'champagne', 'blue', 'midnight_blue', 'ice_blue', 'purple', 'plum', 'aubergine', 'wine', 'dusty_rose', 'pink', 'green', 'emerald', 'sage', 'olive', 'slate'],
};

export const getStorePalettesForStyle = (styleId: StoreTemplateStyleId) => {
  const allowed = STORE_TEMPLATE_PALETTES_BY_STYLE[styleId];
  return STORE_TEMPLATE_PALETTES.filter((palette) => allowed.includes(palette.id));
};
